module.exports = __webpack_public_path__ + "static/media/familias.1d1d9eb4.svg";